export default __webpack_public_path__ + "static/assets/med_pill_round_in_L0_solid_x_01_f.72e8e9f1.png";